@if (!showReplace) {
  <ion-header>
    <ion-row class="ion-align-items-center">
      <div class="column">
        <div class="back" (click)="back()">
          <img src="assets/icon/back.svg" alt="" />
        </div>
        <div class="logo">
          {{ 'fridge.fridge' | translate }} #{{ fridge.inventoryNumber }}
          <div class="shelf-chip">{{ 'fridge.shelf' | translate }} #{{ shelf?.number }}</div>
        </div>
      </div>
    </ion-row>
  </ion-header>
}
@if (!showReplace) {
  <ion-content [forceOverscroll]="false">
    <div class="wrapper">
      <!-- <div
      class="unverified-bar"
      *ngIf="
        section.products[activeIndex] &&
        !section.products[activeIndex]?.hasOwnProperty('acceptedByAi')
      "
      >
      <img src="assets/icon/unverified.svg" alt="" />
      <span>This product is unverified by AI.</span>
    </div> -->
    <!-- <div
    class="ai-unknown-bar"
      *ngIf="
        section.products[activeIndex] &&
        section.products[activeIndex].hasOwnProperty('acceptedByAi') &&
        !section.products[activeIndex]?.acceptedByAi
      "
    >
    <img src="assets/icon/ai-unknown-black.svg" alt="" />
    <span>This product is unknown to AI.</span>
  </div> -->
  <swiper-container
    #swiperEl
    effect="coverflow"
    grab-cursor="true"
    centered-slides="true"
    slides-per-view="2"
    slide-to-clicked-slide="true"
    (swiperslidechange)="onSlideChange($event.detail[0].activeIndex)"
    coverflow-effect='{"rotate":0,"stretch":0,"depth":400,"modifier":1}'
    pagination="true"
    class="mySwiper"
    >
    @for (innerProduct of sectionProducts; track $index; let sectionProductIndex = $index) {
      <swiper-slide>
        <div class="slider-product">
          @if (productService.imagesLinks[innerProduct?.images[0]]?.large) {
            <img
              [src]="productService.imagesLinks[innerProduct?.images[0]]?.large"
              alt=""
              />
          }
          @if (!productService.imagesLinks[innerProduct?.images[0]]?.large) {
            <div class="no-image">
              ?
            </div>
          }
        </div>
      </swiper-slide>
    }
  </swiper-container>
  <!--    <div class="image-holder">-->
  <!--      <img [src]="image" alt="" />-->
  <!--      <div class="section-info">-->
  <!--        <div class="section-info__section">Section {{ section.number }}</div>-->
  <!--        <div class="section-info__stock">-->
  <!--          Stock <span>{{ section.products.length || 0 }}/{{ section.loaded || 0 }}</span> ~-->
  <!--          <span>{{ predictedAvailability }}D</span>-->
<!--        </div>-->
<!--        <div class="section-info__replace" (click)="replace()">-->
<!--          <img src="assets/icon/replace.svg" alt="" />-->
<!--          <span>REPLACE PRODUCT</span>-->
<!--        </div>-->
<!--        <div class="section-info__replace" (click)="remove()">-->
<!--          <img src="assets/icon/remove.svg" alt="" />-->
<!--          <span>REMOVE PRODUCT</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<div class="stock">
  @if (section.products[activeIndex]?.quantity || section.stock?.[activeIndex]?.loaded) {
    <div class="section-info__stock">
      {{ 'product_modal.stock' | translate }}
      <span
        >{{ section.products[activeIndex]?.quantity || 0 }}/{{ section.stock?.[activeIndex]?.loaded || 0 }}</span
        >
        ~
        <span>{{ predictedAvailability }}</span>
      </div>
    } @else {
      <div class="section-info__stock muted">
        {{ 'product_modal.no_stock_data' | translate }}
      </div>
    }
  </div>
  <h2>{{ product.name }}</h2>
  <div class="actions">
    <div class="actions__btn">
      <div class="round-btn" (click)="replace()">
        <img src="assets/icon/replace-new.svg" alt="" />
      </div>
      <span> {{ 'product_modal.replace' | translate }}</span>
    </div>
    <div class="actions__btn">
      <div class="round-btn" (click)="remove()">
        <img src="assets/icon/delete-new.svg" alt="" />
      </div>
      <span> {{ 'product_modal.delete' | translate }}</span>
    </div>
    <div class="actions__btn">
      <div class="round-btn" (click)="edit()">
        <img src="assets/icon/edit.svg" alt="" />
      </div>
      <span> {{ 'product_modal.edit' | translate }}</span>
    </div>
  </div>
  <div class="product">
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.name' | translate }}</div>
        <div class="product-row__value">{{ product.name }}</div>
        <div class="product-row__desc">{{ product.description }}</div>
      </div>
      <div class="product-row__copy" (click)="copyText(product.name)">
        <img src="assets/icon/copy.svg" alt="" />
      </div>
    </div>
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.price' | translate }}</div>
        <div class="product-row__value">
          @if (product.price) {
            <span>{{ fridgeService.getActiveFridgeCurrency() }}</span>
          }
          {{ product.price || '-' }}
        </div>
        <div class="product-row__desc">
          {{ 'product_modal.tax_rate' | translate }} {{ product.taxRate }}%
          @if (!product.isRentable && product.deposit) {
            <span>
              , {{ 'product_modal.deposit' | translate }}
              {{ fridgeService.getActiveFridgeCurrency() }}
              {{ product.deposit || '-' }}
            </span>
          }
        </div>
      </div>
      @if (product.price) {
        <div class="product-row__copy" (click)="copyText(product.price)">
          <img src="assets/icon/copy.svg" alt="" />
        </div>
      }
    </div>
    @if (product.isRentable) {
      <div class="product-row">
        <div>
          <div class="product-row__label">{{ 'edit_product.form.rental_deposit' | translate }}</div>
          <div class="product-row__value">
            @if (product.deposit) {
              <span>{{ fridgeService.getActiveFridgeCurrency() }}</span>
            }
            {{ product.deposit || '-' }}
          </div>
        </div>
      </div>
    }
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.weight' | translate }}</div>
        <div class="product-row__value">
          {{ product.weight || '-' }}
          @if (product.weight && product.weightDeviation) {
            <span>
              &#177;{{ product.weightDeviation }}
            </span>
          }
          @if (product.weight) {
            <span>g</span>
          }
        </div>
      </div>
      @if (product.weight) {
        <div class="product-row__copy" (click)="copyText(product.weight)">
          <img src="assets/icon/copy.svg" alt="" />
        </div>
      }
    </div>
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.article_nr' | translate }}</div>
        <div class="product-row__value">
          {{ product.articleNr || '-' }}
        </div>
      </div>
      @if (product.articleNr) {
        <div
          class="product-row__copy"
          (click)="copyText(product.articleNr)"
          >
          <img src="assets/icon/copy.svg" alt="" />
        </div>
      }
    </div>
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.barcode' | translate }}</div>
        <div class="product-row__value">
          {{ product.barcode || '-' }}
        </div>
      </div>
      @if (product.barcode) {
        <div class="product-row__copy" (click)="copyText(product.barcode)">
          <img src="assets/icon/copy.svg" alt="" />
        </div>
      }
    </div>
    <div class="product-row">
      <div>
        <div class="product-row__label">{{ 'product_modal.ai_id' | translate }}</div>
        <div class="product-row__value">{{ product.aiId || '-' }}</div>
      </div>
      @if (product.aiId) {
        <div class="product-row__copy" (click)="copyText(product.aiId)">
          <img src="assets/icon/copy.svg" alt="" />
        </div>
      }
    </div>
    <div class="bbd-section">
      <div class="product-row__label">{{ 'product_modal.best_before_date' | translate }}</div>
      <div class="bbd-section__row">
        <input type="date" class="bbd-input" [(ngModel)]="bestBeforeDate" [min]="today" />
        <div class="bbd-section__btns">
          <div class="bbd-btn bbd-btn--save" (click)="saveBestBeforeDate()">
            {{ (hasSavedBbd ? 'product_modal.update_bbd' : 'product_modal.save_bbd') | translate }}
          </div>
          @if (bestBeforeDate) {
            <div class="bbd-btn bbd-btn--clear" (click)="clearBestBeforeDate()">
              {{ 'product_modal.clear_bbd' | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (fridgeService.inventoryProcess) {
    <div class="amount">
      <div class="qty">
        <div class="label">{{ 'product_modal.default' | translate }}</div>
        <div class="picker">
          <div class="minus" (click)="minus()">
            <img src="assets/icon/minus.svg" alt="" />
          </div>
          <div class="number">x{{ qty }}</div>
          <div class="plus" (click)="plus()">
            <img src="assets/icon/plus.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="btn" (click)="back()">{{ 'product_modal.cancel' | translate }}</div>
        <div class="btn filled" (click)="changeQuantity()">
          {{ 'product_modal.confirm' | translate }}
        </div>
      </div>
    </div>
  }
</div>
</ion-content>
}

@if (showReplace) {
  <app-replace-product
    [sectionId]="section._id"
    [position]="activeIndex"
    (closeModal)="back()"
    [rackNumber]="rackNumber"
    (goBack)="goBack()"
  ></app-replace-product>
}
